import { Box } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";

const SkeletonTile = ({ dataId }: { dataId: string }) => (
  <Box
    display="flex"
    width="full"
    flexDirection={"row"}
    alignItems={"center"}
    gap="small"
    data-id={dataId}
    backgroundColor="white"
    borderRadius={"small"}
    padding="small"
  >
    <Skeleton width={20} backgroundColor="dark" height={35} />
    <Box width="full">
      <Skeleton variant="text" width="60%" backgroundColor="dark" height={35} />
    </Box>
  </Box>
);

export const QuickActionsSkeleton = () => {
  return (
    <Box data-id="quick-actions">
      <Box display="flex" width="full" gap="small" flexDirection={"column"}>
        <SkeletonTile dataId="quick-actions-skeleton-tile-1" />
        <SkeletonTile dataId="quick-actions-skeleton-tile-2" />
        <SkeletonTile dataId="quick-actions-skeleton-tile-3" />
      </Box>
    </Box>
  );
};
